import { createFileRoute } from '@tanstack/react-router';
import { MigrationPage } from '@/features/settings/migration/migration-page';

export const Route = createFileRoute('/_app/settings/migration')({
  component: MigrationPage,
});
